import { FC } from 'react';
import { GlitterIcon } from 'assets/icons';

interface AutoFilledIndicatorProps {
  className?: string;
  isAutoFilled?: boolean;
}

const AutoFilledIndicator: FC<AutoFilledIndicatorProps> = ({ className = '', isAutoFilled = false }) => {
  if (isAutoFilled) {
    return (
      <span className={`ml-2 h-[15px] ${className}`} style={{ display: 'inline-block' }}>
        <GlitterIcon />
      </span>
    );
  }
  return null;
};

export default AutoFilledIndicator;
